module.exports = __webpack_public_path__ + "static/media/ic_projects.5ea3b05b.svg";